<template>
  <b-container fluid class="paquetes">
    <loading :active.sync="isLoading" color="#00AB63"></loading>
    <b-row>
      <b-col sm="12">
        <div class="my-3 p-3 bg-white rounded shadow-sm">
          <h4 class="border-bottom border-gray pb-2 mb-0">Agregar paquete</h4>
          <div class="media text-muted pt-3">
            <b-form @submit="save($event)" style="width: 100%;">
              <b-row>
                <b-col sm="4">
                  <b-form-group label="Nombre:">
                    <b-form-input placeholder="Nombre del paquete" v-model="name" required></b-form-input>
                  </b-form-group>
                </b-col>
              </b-row>
              <listaProductos
                :rows="rows"
                :productTypes="productTypes"
                :products="products"
                :AllProductsOptions="AllProductsOptions"
                :getTotalPrice="getTotalPrice"
                :getTotal="getTotal"
                :verifyQuantity="verifyQuantity"
                :selectProduct="selectProduct"
              ></listaProductos>
              <b-row class="mt-3">
                <b-col>
                  <b-form-group label="Compatible con:">
                    <b-form-radio-group
                      :options="compatibilidad"
                      v-model="compatibilidadSelected"
                      :required="checkbox"
                    />
                  </b-form-group>
                </b-col>
                <b-col>
                  <b-form-group label="Cotizador:">
                    <b-form-radio-group
                      :options="estados"
                      v-model="estadoSelected"
                      :required="checkbox"
                    />
                  </b-form-group>
                </b-col>
                <b-col>
                  <b-form-group label="Front:">
                    <b-form-radio-group
                      :options="estados"
                      v-model="frontSelected"
                      :required="checkbox"
                    />
                  </b-form-group>
                </b-col>
                <b-col>
                  <b-form-group label="Auto calcular cantidades:">
                    <b-form-radio-group
                      :options="estados"
                      v-model="automaticSelected"
                      :required="checkbox"
                    />
                  </b-form-group>
                </b-col>
                <b-col>
                  <b-form-group label="Dolar:">
                    <b-form-input v-model="dollar" />
                  </b-form-group>
                  <b-button class="boton_createch" block @click="updateDollar()">
                    <i class="far fa-save"></i> Guardar valor de dolar
                  </b-button>
                </b-col>
              </b-row>
              <tablaProductos
                :rows="rows"
                :products="products"
                :total="total"
                :totalPesos="totalPesos"
                :subtotal="subtotal"
                :subtotalPesos="subtotalPesos"
                :totalIVA="totalIVA"
                :totalIVAPesos="totalIVAPesos"
                :disc="disc"
                :discPesos="discPesos"
                :cuota="cuota"
                :totalMasCuota="totalMasCuota"
                :cuotaPesos="cuotaPesos"
                :totalMasCuotaPesos="totalMasCuotaPesos"
                :getTotalPrice="getTotalPrice"
                :getTotal="getTotal"
                :verifyQuantity="verifyQuantity"
                v-on:getDiscountValue="getDiscountValue"
                v-on:getDiscountPesosValue="getDiscountPesosValue"
              ></tablaProductos>
              <b-row>
                <b-col>
                  <b-button
                    v-if="!actualizar"
                    variant="primary"
                    class="float-right boton_createch"
                    type="submit"
                  >
                    <i class="far fa-save"></i> Guardar
                  </b-button>
                  <div v-else>
                    <b-button variant="primary" class="float-right" type="submit">
                      <i class="far fa-save"></i> Actualizar
                    </b-button>
                    <b-button variant="secondary" class="float-right mr-1" @click="resetForm();">
                      <i class="fas fa-undo-alt"></i> Cancelar
                    </b-button>
                  </div>
                </b-col>
              </b-row>
            </b-form>
          </div>
        </div>
      </b-col>
    </b-row>
    <b-row>
      <b-col>
        <div class="my-3 p-3 bg-white rounded shadow-sm">
          <h4 class="border-bottom border-gray pb-2 mb-0">Paquetes</h4>

          <div class="media text-muted pt-3">
            <b-container fluid>
              <!-- User Interface controls -->
              <b-row class="mb-4">
                <b-col sm="10">
                  <b-form-group label="Buscar" label-for="filterInput" class="mb-0">
                    <b-input-group size="sm">
                      <b-form-input
                        v-model="packagesTable.filter"
                        type="search"
                        placeholder="Nombre del paquete"
                        id="filterInput"
                      ></b-form-input>
                      <b-input-group-append>
                        <b-button
                          :disabled="!packagesTable.filter"
                          @click="packagesTable.filter = ''"
                        >Borrar</b-button>
                      </b-input-group-append>
                    </b-input-group>
                  </b-form-group>
                </b-col>
                <b-col sm="2">
                  <b-form-group label="Por Pagina" label-for="perPageSelect" class="mb-0">
                    <b-form-select
                      v-model="packagesTable.perPage"
                      id="perPageSelect"
                      size="sm"
                      :options="packagesTable.pageOptions"
                    ></b-form-select>
                  </b-form-group>
                </b-col>
              </b-row>
              <!-- Main table element -->
              <b-table
                show-empty
                small
                stacked="md"
                :items="packages"
                :fields="packagesTable.fields"
                :current-page="packagesTable.currentPage"
                :per-page="packagesTable.perPage"
                :filter="packagesTable.filter"
                :filterIncludedFields="packagesTable.filterOn"
                @filtered="onFiltered"
              >
                <template v-slot:cell(name)="row">{{ row.value.first }} {{ row.value.last }}</template>
                <template v-slot:cell(actions)="row">
                  <!-- <b-button size="sm" @click="view(row.item._id)" class="mr-1" variant="light"><i class="far fa-eye"></i></b-button> -->
                  <b-button @click="update(row.item)" class="mr-1 btn_editar">
                    <i class="far fa-edit"></i>
                  </b-button>

                  <b-button
                    size="sm"
                    @click="modalDelete(row.item,$event.target)"
                    class="mr-1 btn_borrar"
                  >
                    <i class="far fa-trash-alt"></i>
                  </b-button>
                </template>
                <template v-slot:row-details="row">
                  <b-card>
                    <ul>
                      <li v-for="(value, key) in row.item" :key="key">{{ key }}: {{ value }}</li>
                    </ul>
                  </b-card>
                </template>
              </b-table>
              <b-container>
                <b-row class="justify-content-end">
                  <b-col sm="5">
                    <b-pagination
                      v-model="packagesTable.currentPage"
                      :total-rows="packagesTable.totalRows"
                      :per-page="packagesTable.perPage"
                      align="fill"
                      size="sm"
                      class="my-0"
                    ></b-pagination>
                  </b-col>
                </b-row>
              </b-container>
            </b-container>
          </div>
        </div>
      </b-col>
    </b-row>
    <!-- Delete modal -->
    <b-modal
      :id="deleteModal.id"
      :title="deleteModal.title"
      @ok="deletePackage()"
      centered
      ok-title="Eliminar"
      cancel-title="Cancelar"
    >
      <p
        style="text-align:center; font-size:25px; font-weight:bold;"
      >¿Está seguro que desea eliminar?</p>
    </b-modal>
  </b-container>
</template>
<script>
import axios from "axios";
// Import component
import Loading from "vue-loading-overlay";
// Import stylesheet
import "vue-loading-overlay/dist/vue-loading.css";

import listaProductos from "../components/paquetes/listaProductos";
import tablaProductos from "../components/paquetes/tablaProductos";
export default {
  components: {
    Loading,
    listaProductos,
    tablaProductos
  },
  data() {
    return {
      isLoading: false,
      name: "",
      products: [],
      actualizar: false,
      packageId: null,
      AllProductsOptions: [{ text: "Selecciona producto", value: null }],
      rows: [
        {
          product: null,
          quantity: 1,
          options: [],
          type: null,
          price: 0,
          pricePesos: 0,
          disc: 0,
          discPesos: 0,
          showDisc: false
        }
      ],
      productTypes: [],
      subtotal: 0,
      subtotalPesos: 0,
      total: 0,
      totalPesos: 0,
      totalIVA: 0,
      totalIVAPesos: 0,
      disc: 0,
      discPesos: 0,
      iva: 16,
      dollar: 20,
      percentage: 0,
      cuota: 0,
      cuotaPesos: 0,
      totalMasCuota: 0,
      totalMasCuotaPesos: 0,
      packages: [],
      packagesTable: {
        fields: [
          {
            key: "packageName",
            sortable: true,
            label: "Nombre",
            thStyle: { width: "90%" }
          },
          { key: "actions", label: "", thStyle: { width: "10%" } }
        ],
        totalRows: 1,
        currentPage: 1,
        perPage: 5,
        pageOptions: [5, 10, 15],
        filter: null,
        filterOn: []
      },
      deleteModal: {
        id: "info-modal",
        title: "",
        eliminar: null
      },
      checkbox: true,
      compatibilidadSelected: "",
      compatibilidad: [
        { text: "Comercial", value: "Comercial" },
        { text: "Doméstico", value: "Doméstico" },
        { text: "Industrial", value: "Industrial" }
      ],
      estadoSelected: "",
      frontSelected: "",
      automaticSelected: '',
      estados: [
        { text: "Si", value: true },
        { text: "No", value: false }
      ]
    };
  },
  created() {
    this.getProducts();
    this.getProductTypes();
    this.getTotal();
    this.getPackages();
    this.getCompanyValues();
  },
  computed: {
    sortOptions() {
      return this.fields
        .filter(f => f.sortable)
        .map(f => {
          return { text: f.label, value: f.key };
        });
    }
  },
  watch: {
    compatibilidadSelected: function(newValue, old) {
      if (newValue.length > 0) {
        this.checkbox = false;
      } else {
        this.checkbox = true;
      }
    },
    disc: function(newValue, oldValue) {
      this.getTotal();
    },
    discPesos: function(newValue, oldValue) {
      this.getTotal();
    },
    dollar: function(newValue, oldValue) {
      this.rows.map(row => {
        row.pricePesos = row.price * newValue;
      });
      this.getTotal();
    }
  },
  methods: {
    selectProduct(index){ 
      this.getTotalPrice(index);  
    },
    getCompanyValues() {
      axios
        .get(`values/${this.$store.state.usuario.empresa}`)
        .then(res => {
          this.dollar = res.data.dollar;
          this.percentage = res.data.percentage;
        })
        .catch(error => {
          this.dollar = 20;
        });
    },
    updateDollar() {
      axios
        .put(`company/${this.$store.state.usuario.empresa}/dollar`, {
          dollar: this.dollar
        })
        .then(res => {
          this.makeToast("Valor de dolar guardado", "Paquetes");
        })
        .catch(error => {
          this.makeToast(
            "Ocurrió un error al guardar el valor de dolar",
            "Paquetes"
          );
        });
    },
    getPackages() {
      axios.get("packages").then(res => {
        this.packages = res.data;
        this.packagesTable.totalRows = res.data.length;
        this.isLoading = false;
      });
    },
    getProducts() {
      this.isLoading = true;
      axios.get("products").then(res => {
        if (res.data) {
          this.products = res.data;
          for (const p of this.products) {
            if (p.brand != null && p.brand.name) {
              this.AllProductsOptions.push({
                text: `${p.productName} Marca: ${p.brand.name}`,
                value: this.products.indexOf(p)
              });
            } else {
              this.AllProductsOptions.push({
                text: `${p.productName} Marca: N/A`,
                value: this.products.indexOf(p)
              });
            }
          }
          this.rows[0].options = [...this.AllProductsOptions];
        }
      });
    },
    getProductTypes() {
      axios
        .get("types")
        .then(res => {
          if (res.data) {
            this.productTypes.push({ text: "Selecciona tipo", value: null });
            for (const type of res.data) {
              this.productTypes.push({ text: type.name, value: type._id });
            }
          }
        })
        .catch(error => {});
    },
    save(event) {
      event.preventDefault();
      if (this.actualizar === true) {
        this.updatePackage();
      } else {
        this.savePackage();
      }
    },
    savePackage() {
      let pack = {
        name: this.name,
        products: [],
        disc: this.disc,
        discPesos: this.discPesos,
        compatibility: this.compatibilidadSelected,
        public: this.estadoSelected,
        front: this.frontSelected,
        automatic: this.automaticSelected
      };
      for (const r of this.rows) {
        pack.products.push({
          product: this.products[r.product]._id,
          quantity: r.quantity,
          disc: r.disc,
          discPesos: r.discPesos
        });
      }
      axios
        .post("package", pack)
        .then(res => {
          if (res.status === 202) {
            this.makeToast("Ya existe un paquete con ese nombre", "Paquetes");
          } else {
            this.resetForm();
            this.getPackages();
          }
        })
        .catch(error => {
          this.makeToast("Ocurrió un error inesperado", "Error");
        });
    },
    update(item) {
      this.actualizar = true;
      this.packageId = item._id;
      let products = [];
      item.products.forEach(element => {
        let options = [];
        const newOptions = this.products.filter(
          p => p.type._id == element.type
        );
        newOptions.map(p => {
          if (p.brand != null && p.brand.name) {
            options.push({
              text: `${p.productName} Marca: ${p.brand.name}`,
              value: this.products.indexOf(p)
            });
          } else {
            options.push({
              text: `${p.productName} Marca: N/A`,
              value: this.products.indexOf(p)
            });
          }
        });
        const p = this.products.filter(e => e._id === element.product);
        if (p.length > 0) {
          const productIndex = this.products.indexOf(p[0]);
          const product = this.products[productIndex];
          let row = {
            type: element.type,
            product: productIndex,
            quantity: element.quantity,
            options: options,
            compatibility: null,
            disc: element.disc,
            discPesos: element.discPesos,
            showDisc: false
          };
          if (product.priceWDisc && product.priceWDisc > 0) {
            row.price =
              this.products[productIndex].priceWDisc * element.quantity -
              element.disc -
              element.discPesos / this.dollar;
            row.pricePesos =
              this.products[productIndex].priceWDisc *
                this.dollar *
                element.quantity -
              element.disc * this.dollar -
              element.discPesos;
          } else {
            row.price =
              this.products[productIndex].price * element.quantity -
              element.disc -
              element.discPesos / this.dollar;
            row.pricePesos =
              this.products[productIndex].price *
                this.dollar *
                element.quantity -
              element.disc * this.dollar -
              element.discPesos;
          }
          products.push(row);
        }
      });  
      this.compatibilidadSelected = item.compatibility;
      this.name = item.packageName;
      this.rows = products;
      this.disc = item.disc;
      this.discPesos = item.discPesos;
      this.estadoSelected = item.public;
      this.frontSelected = item.front;
      this.automaticSelected = item.automatic;
      this.getTotal();
      this.scrollUp();
    },
    updatePackage() {
      let pack = {
        name: this.name,
        products: [],
        disc: this.disc,
        discPesos: this.discPesos,
        compatibility: this.compatibilidadSelected,
        public: this.estadoSelected,
        front: this.frontSelected,
        automatic: this.automaticSelected
      };
      for (const r of this.rows) {
        pack.products.push({
          product: this.products[r.product]._id,
          quantity: r.quantity,
          disc: r.disc,
          discPesos: r.discPesos
        });
      }
      axios
        .put(`package/${this.packageId}`, pack)
        .then(res => {
          if (res.status === 202) {
            this.makeToast("Ya existe un paquete con ese nombre", "Paquetes");
          } else {
            this.resetForm();
            this.getPackages();
          }
        })
        .catch(error => {
          this.makeToast("Ocurrió un error inesperado", "Error");
        });
    },
    modalDelete(item, button) {
      this.deleteModal.eliminar = item._id;
      this.deleteModal.title = `Eliminar empleado: ${item.packageName}`;
      this.$root.$emit("bv::show::modal", this.deleteModal.id, button);
    },
    deletePackage() {
      axios
        .delete(`package/${this.deleteModal.eliminar}`)
        .then(res => {
          this.getPackages();
        })
        .catch(error => {
          this.makeToast("Ocurrió un error inesperado", "Error");
        });
    },
    getTotalPrice(index) {
      if (this.rows[index].product != null) {
        if (
          this.products[this.rows[index].product].priceWDisc &&
          this.products[this.rows[index].product].priceWDisc > 0
        ) {
          this.rows[index].price =
            this.products[this.rows[index].product].priceWDisc *
              this.rows[index].quantity -
            this.rows[index].disc -
            this.rows[index].discPesos / this.dollar;
          this.rows[index].pricePesos = this.rows[index].price * this.dollar;
        } else {
          this.rows[index].price =
            this.products[this.rows[index].product].price *
              this.rows[index].quantity -
            this.rows[index].disc -
            this.rows[index].discPesos / this.dollar;
          this.rows[index].pricePesos = this.rows[index].price * this.dollar;
        }
      } else {
        this.rows[index].price = 0;
        this.rows[index].quantity = 1;
      }
      this.getTotal();
    },
    getTotal() {
      this.subtotal = 0;
      let sumaUSD = this.rows.reduce((total, item) => {
        return item.price + total;
      }, 0);
      this.subtotal = sumaUSD;
      this.totalIVA = this.subtotal * (this.iva / 100);
      this.total = this.subtotal + this.totalIVA;
      if (isNaN(this.disc)) {
        this.disc = 0;
      }
      if (isNaN(this.discPesos)) {
        this.discPesos = 0;
      }
      this.total -= this.disc - this.discPesos / this.dollar;
      this.subtotalPesos = this.subtotal * this.dollar;
      this.totalIVAPesos = this.subtotalPesos * (this.iva / 100);
      this.totalPesos =
        this.subtotalPesos +
        this.totalIVAPesos -
        this.disc * this.dollar -
        this.discPesos;
      this.cuota = (this.total * this.percentage) / 100;
      this.cuotaPesos = this.cuota * this.dollar;
      this.totalMasCuota = this.total + this.cuota;
      this.totalMasCuotaPesos = this.totalMasCuota * this.dollar;
    },
    verifyQuantity(event) {
      event = event ? event : window.event;
      var charCode = event.which ? event.which : event.keyCode;
      if (charCode > 47 && charCode < 58) {
        return true;
      } else {
        event.preventDefault();
      }
    },
    onFiltered(filteredItems) {
      this.packagesTable.totalRows = filteredItems.length;
      this.packagesTable.currentPage = 1;
    },
    resetForm() {
      this.rows = [
        {
          product: null,
          quantity: 1,
          options: [],
          type: null,
          price: 0,
          pricePesos: 0,
          disc: 0,
          discPesos: 0,
          showDisc: false
        }
      ];
      this.rows[0].options = [...this.AllProductsOptions];
      this.name = "";
      this.disc = 0;
      this.total = 0;
      this.subtotal = 0;
      this.subtotalPesos = 0;
      this.total = 0;
      this.totalPesos = 0;
      this.totalIVA = 0;
      this.totalIVAPesos = 0;
      this.disc = 0;
      this.discPesos = 0;
      this.actualizar = false;
      this.compatibilidadSelected = "";
      this.scrollUp();
    },
    scrollUp() {
      document.body.scrollTop = 0;
      document.documentElement.scrollTop = 0;
    },
    getDiscountValue(value) {
      this.disc = parseFloat(value);
      this.getTotal();
    },
    getDiscountPesosValue(value) {
      this.discPesos = parseFloat(value);
      this.getTotal();
    }
  }
};
</script>

<style>
html {
  scroll-behavior: smooth;
}
</style>